import { cn } from "@/lib/utils";

export type ExamAnswerOptionState =
  | "default"
  | "selected"
  | "correct"
  | "incorrect";

interface ExamAnswerOptionProps {
  answer: string;
  onSelect: () => void;
  state: ExamAnswerOptionState;
  statusText?: string;
}

const stateClassNames: Record<ExamAnswerOptionState, string> = {
  default: "border-[#dddfe4] bg-[#f4f4f6]",
  selected: "border-[3px] border-[#0a0c11] bg-[#f4f4f6]",
  correct: "border-2 border-[#43b047] bg-[#eaf7ef]",
  incorrect: "border-2 border-[#e50509] bg-[rgba(229,5,9,0.12)]",
};

export const ExamAnswerOption = ({
  answer,
  onSelect,
  state,
  statusText,
}: ExamAnswerOptionProps) => (
  <button
    className={cn(
      "flex min-h-[72px] w-full items-center gap-3 rounded-2xl border p-6 text-left text-base leading-6 transition-colors",
      stateClassNames[state],
    )}
    data-answer-state={state}
    data-testid="answer-option"
    onClick={onSelect}
    type="button"
  >
    {statusText && <span className="sr-only">{statusText}</span>}
    <span>{answer}</span>
  </button>
);
